export default class StateMachine {
	initialize(startingState) {
		this.currentState = startingState;
		console.log(this.currentState.toString());
		this.currentState.enterFrom(null);
	}

	changeState(newState) {
		console.log(
			'ChangeState; oldstate: ' +
				(this.currentState === null ? 'null' : this.currentState.toString()) +
				'; newState: ' +
				(newState === null ? 'null' : newState.toString())
		);
		var old = this.currentState;
		this.currentState.exitTo(newState);
		this.currentState = newState;
		newState.enterFrom(old);
	}
}
